function menu() {
	let button_show_menu = document.querySelector('.show_menu_mobile');
	let button_close_menu = document.querySelector('.close_menu_mobile');

	if (!button_show_menu) {
	} else {
		button_show_menu.addEventListener('click', function(e){
			e.preventDefault();
			toggler();
		});
	}
	if (!button_close_menu) {
	} else {
		button_close_menu.addEventListener('click', function(e){
			e.preventDefault();
			toggler();
		});
	}

}

function toggler() {
	let set_menu_devices = document.querySelector('header.set_menu_devices');
	let body = document.querySelector('body');
	set_menu_devices.classList.toggle('get_menu_mobile');
	body.classList.toggle('body_search_oh');
}

export { menu, toggler };
